export enum Shift {
  DAY = "1",
  NIGHT = "3",
  GRAVEYARD = "5",
  COASTWISE = "67",
  SQUAMISH = "68",
}

export const Shifts: Shift[] = [
  Shift.DAY,
  Shift.NIGHT,
  Shift.GRAVEYARD,
  Shift.COASTWISE,
  Shift.SQUAMISH
];